import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await api.post('/users/login', { email, password });
      const { token, user } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      const role = user.role.name;


      switch (role) {
        case "Administrador":
          navigate("/dashboard");
          break;

        case "Activos":
          navigate("/actives");
          break;

        case "Admin-Odontologia":
          navigate("/actives");
          break;

        case "Facturacion":
          navigate("/invoices");
          break;

        case "Dashboards":
          navigate("/dashboard");
          break;

        case "Insumos":
          navigate("/dashboard");
          break;

        case "Solicitudes":
          navigate("/requests");
          break;

        default:
          navigate("/login");
      }

    } catch (err) {
      console.error(err);
      setError('Correo o contraseña incorrectos');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-2xl shadow-blue-900/30 max-w-4xl w-full flex overflow-hidden">

        {/* Lado izquierdo */}
        <div className="w-1/2 p-10">
          <h2 className="text-3xl font-bold mb-6 text-gray-800">
            Iniciar sesión
          </h2>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block mb-2 text-gray-600 font-semibold">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-800"
              />
            </div>

            <div>
              <label className="block mb-2 text-gray-600 font-semibold">
                Contraseña
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-800"
              />
            </div>

            {error && (
              <p className="text-red-500 text-sm">{error}</p>
            )}

            <button
              type="submit"
              className="w-full py-3 bg-blue-900 hover:bg-blue-800 text-white font-bold rounded-md transition"
            >
              Ingresar
            </button>
          </form>
        </div>

        {/* Lado derecho */}
        <div className="w-1/2 bg-blue-900 text-white flex flex-col items-center p-10">
          <h3 className="text-4xl font-bold tracking-wide mb-1">Medicare IPS</h3>
          <img
            src="/mune.png"
            alt="Medicare IPS"
            className="mt-2 w-72 h-72 object-contain"
          />
        </div>

      </div>
    </div>
  );
}

export default Login;
